import { ShopPurchaseData } from "./shop";

const Payments = {
  interval: null,
  windowReference: null,
  init: async() => {
    await paymentsYG.getPurchases().then(async _purchases => {
      if (_purchases.length > 0) await Payments.consumePaidPurchases(_purchases);
    });
    await paymentsYG.getCatalog().then(_catalog => {
      Payments.catalog = _catalog;
    });
  },

  buyMoreSTD: async STD => {
    await paymentsYG.purchase(`std${STD}`).then(async _purchase => {
      ShopPurchaseData.setLocalSTD(await ShopPurchaseData.getRemoteSTD());
      const newData = ShopPurchaseData.getLocalSTD();
      newData.totalSTD += STD;
      ShopPurchaseData.setLocalSTD(newData);
      await ShopPurchaseData.setRemoteSTD(newData);
      paymentsYG.consumePurchase(_purchase.purchaseToken);
      GameUI.notify.success(`Покупка ${STD} ЗППП прошла успешно, спасибо за вашу поддержку! ❤️`, 10000);
    });
    GameStorage.save();
  },

  consumePaidPurchases: async _purchases => {
    const currentData = await ShopPurchaseData.getRemoteSTD();
    let consumedSTD = 0;
    for (const _purchase of _purchases) {
      consumedSTD += parseInt(_purchase.productID.substring(3), 10);
      paymentsYG.consumePurchase(_purchase.purchaseToken);
    }
    currentData.totalSTD += consumedSTD;
    ShopPurchaseData.setLocalSTD(currentData);
    await ShopPurchaseData.setRemoteSTD(currentData);
    GameUI.notify.success(`Покупка ${consumedSTD} ЗППП прошла успешно, спасибо за вашу поддержку! ❤️`, 10000);
  },

  getPriceText: amount => {
    for (const product of Payments.catalog) {
      if (product.id === `std${amount.toString()}`) {
        return product.price;
      }
    }
    throw new Error(`no product with ${amount} amount`);
  },
};

export default Payments;
